import { Directive, ElementRef, Inject, Input } from '@angular/core';
import { take } from 'rxjs';
import { SocialAuthService } from '../socialauth.service';
import { ENVIRONMENT_TOKEN } from '../../../injection.tokens';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'login-google-button'
})
export class GoogleButtonDirective {
  @Input() width: string = '';
  @Input() locale: string = '';
  @Input()
  fullLabel: string = 'Google';

  @Input()
  shortLabel: string = '';
  @Input() img: string | null = null;

  constructor(@Inject(ENVIRONMENT_TOKEN) private environment: any, el: ElementRef, socialAuthService: SocialAuthService) {
    if (!environment?.externalAuthProviders?.google?.clientId?.length) {
      return;
    }

    const createGoogleLoginWrapper = (locale) => {
      const googleLoginWrapper = document.createElement('div');
      googleLoginWrapper.style.display = 'none';
      googleLoginWrapper.classList.add('custom-google-button');

      document.body.appendChild(googleLoginWrapper);

      google.accounts.id.renderButton(googleLoginWrapper, {
        type: 'icon',
        size: 'small',
        locale: locale
      });

      const googleLoginWrapperButton = googleLoginWrapper.querySelector('div[role=button]') as HTMLDivElement;
      return {
        click: () => {
          googleLoginWrapperButton.click();
        }
      };
    };

    socialAuthService.initState.pipe(take(1)).subscribe(() => {
      Promise.resolve(this.width).then((value) => {
        if (value > '400' || (value < '200' && value != '')) {
          Promise.reject('Please note .. max-width 400 , min-width 200 ' + '(https://developers.google.com/identity/gsi/web/tools/configurator)');
        } else {
          const googleButtonWrapper = createGoogleLoginWrapper(this.locale);
          window['handleGoogleLogin'] = () => {
            googleButtonWrapper.click();
          };

          const div = document.createElement('div');
          div.setAttribute('class', 'sm-login-btn google');
          div.setAttribute('onclick', 'handleGoogleLogin()');
          div.setAttribute('aria-label', this.fullLabel);

          if (this.img) {
            const img = document.createElement('img');
            img.setAttribute('src', this.img);
            img.setAttribute('aria-hidden', 'true');
            div.appendChild(img);
          } else {
            const icon = document.createElement('i');
            icon.setAttribute('class', 'fab fa-google');
            div.appendChild(icon);
          }

          const fullLabel = document.createElement('span');
          fullLabel.setAttribute('class', 'full-label');
          fullLabel.setAttribute('aria-hidden', 'true');
          fullLabel.textContent = this.fullLabel;
          div.appendChild(fullLabel);

          if (this.shortLabel) {
            const shortLabel = document.createElement('span');
            shortLabel.setAttribute('class', 'short-label');
            shortLabel.setAttribute('aria-hidden', 'true');
            shortLabel.textContent = this.shortLabel;
            div.appendChild(shortLabel);
          }

          if (el.nativeElement) {
            el.nativeElement.appendChild(div);
          }
        }
      });
    });
  }
}
